<div _ngcontent-serverapp-c62="" class="back2top" [ngClass]="showButton()" (click)="scrollToTop()">
  <img src="../../../assets/icons/arrow-up.svg" alt="" />
</div>
